// 导入 抽取的 请求对象
import ajaxRequest from '../utils/request';

const reFix = '/productadmin/Notice';

// 获取列表
export function getNoticePersonPageApi(params) {
  return ajaxRequest({
    url: reFix + '/notice_person_page',
    method: 'GET',
    params,
  });
}

// 新增
export function addNoticeApi(data) {
  return ajaxRequest({
    url: reFix + '/add',
    method: 'POST',
    data,
  });
}
// 编辑
export function editNoticeApi(data) {
  return ajaxRequest({
    url: reFix + '/edit',
    method: 'POST',
    data,
  });
}

// 删除
export function noticeDeleteApi(data) {
  return ajaxRequest({
    url: reFix + '/delete',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    method: 'POST',
    data,
  });
}

// 复核
export function updateReviewStatusApi(data) {
  return ajaxRequest({
    url: '/productAdmin/House/UpdateReviewStatus',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    method: 'PUT',
    data,
  });
}
// URL：/productAdmin/House/UpdateReviewStatus
// 请求方式：Put
// 请求参数:
// {
//   "houseRateId": "",//楼盘佣金id
//   "reviewStatus": 0,//复核状态 0：未复核 1：已复核，2：驳回
//   "reviewOpinion": ""  // 复核意见
// }
